/**
 * Проверка url строки на внешний или внутренней url
 * @param url - внешняя или внутрення ссылка
 */
export const checkUrlIsExternal = (url: string | undefined): boolean =>
  typeof url === 'string' && url.includes('http')
